import React, { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@mui/material/styles";
import { Box, Button, Stack, Typography } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";

import { KernelLockup, Loading, resume, signIn, signOut, theme } from "@lopie/kernel-ui";

import App from "./App.jsx";

function Shell() {
  const [session, setSession] = useState(null);
  const [ready, setReady] = useState(false);
  const [deliberate, setDeliberate] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (new URLSearchParams(window.location.search).has("signedout")) {
      setDeliberate(true);
      setReady(true);
      return;
    }
    resume()
      .then((s) => {
        setSession(s);
        if (!s) signIn();
      })
      .catch((e) => setError(e.message))
      .finally(() => setReady(true));
  }, []);

  if (!ready) return <Loading label="Restoring your session" minHeight="100vh" />;

  if (!session) {
    return (
      <Stack spacing={2} sx={{ p: 4, alignItems: "flex-start" }}>
        <KernelLockup />
        <Typography variant="h1">Transaction Risk</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: "60ch" }}>
          {deliberate
            ? "You are signed out."
            : error || "This app signs you in through the same kernel as everything else."}
        </Typography>
        <Button variant="contained" onClick={signIn}>
          Sign in
        </Button>
      </Stack>
    );
  }

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
      <Box sx={{ height: 2, bgcolor: "primary.main" }} />
      <App
        token={session.token}
        claims={session.claims}
        onSignOut={() => signOut()}
      />
    </Box>
  );
}

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ThemeProvider theme={theme} defaultMode="system">
      <CssBaseline enableColorScheme />
      <Shell />
    </ThemeProvider>
  </React.StrictMode>,
);
